import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import BlockIcon from '@mui/icons-material/Block';
import CancelIcon from '@mui/icons-material/Cancel';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';

/** A booking that has ended: on the grid for the past hours of today, and read-only. */
export const isClosedStatus = (status) => status === 'COMPLETED' || status === 'EXPIRED';

/** Shared by both dashboard views so a status never reads differently between them. */
export const getStatusConfig = (status) => {
  switch (status) {
    case 'BOOKED':
      return { label: 'Véglegesítve', bg: '#e8f5e9', border: '#4caf50', chipBg: '#4caf50', Icon: CheckCircleIcon };
    case 'PRE_RESERVED':
      return { label: 'Előfoglalt', bg: '#e3f2fd', border: '#1e88e5', chipBg: '#1e88e5', Icon: HourglassEmptyIcon };
    case 'PENDING':
      return { label: 'Jóváhagyásra vár', bg: '#fff8e1', border: '#ff9800', chipBg: '#ff9800', Icon: HourglassEmptyIcon };
    case 'BLOCKED':
      return { label: 'Letiltva', bg: '#ffebee', border: '#f44336', chipBg: '#f44336', Icon: BlockIcon };
    // Faded on purpose: today's past hours must not draw the eye from what is still ahead. The
    // chip is darker than the block so its white label stays readable.
    case 'COMPLETED':
      return { label: 'Teljesült', bg: '#eef3ef', border: '#a7bfae', chipBg: '#6f8c77', Icon: TaskAltIcon };
    case 'EXPIRED':
      return { label: 'Lejárt', bg: '#f2eff6', border: '#b8aecb', chipBg: '#857aa0', Icon: HistoryToggleOffIcon };
    // Never on the grid, which draws only live bookings, but a details card can show one.
    case 'REJECTED':
      return { label: 'Elutasítva', bg: '#fbe9e7', border: '#d84315', chipBg: '#d84315', Icon: CancelIcon };
    default:
      return { label: status, bg: '#f5f5f5', border: '#9e9e9e', chipBg: '#9e9e9e', Icon: HourglassEmptyIcon };
  }
};

/** Free-capacity colouring for the resource board's per-slot strip. */
export const getCapacityColor = (freeRatio) => {
  if (freeRatio <= 0) return '#f44336';
  if (freeRatio <= 0.34) return '#ff9800';
  return '#4caf50';
};
